module.exports = __webpack_public_path__ + "static/img/paymaya-icon.dce1e9e9.png";